import { ProfileQL } from "../../../models/Profile";

// USED To enable a Feature Flag conditional to ONLY allow plan based payment and hide "Recarga" options

const RECARGA_CUTOFF_DATE = new Date(2026, 5, 30); // June 30th, 2026
const FOUR_MONTHS_IN_MS = 120 * 24 * 60 * 60 * 1000; // Approximation of four months in milliseconds

export const onlyPaymentPlansFeatureFlag = (currentUser: ProfileQL) => {
    if(!currentUser?.billing) return true;  // Guard, but shouldn't happen
    if (Date.now() > RECARGA_CUTOFF_DATE.getTime()) return true;

    const _billing = currentUser.billing;

    if (_billing.hasStripeSubscription) return true; // Redundant, but left for feature consistency
    if (!_billing.lastPaymentId) return true; // Hasn't made a previous payment, Only plan options
    if (!_billing.lastPayment) return true; // Guard, should be consistent with lastPaymentId.

    const lastPaymentMoreThanFourMonthsAgo = (Date.now() - _billing.lastPayment) > FOUR_MONTHS_IN_MS;
    if (lastPaymentMoreThanFourMonthsAgo) return true; // If the last payment was more than 4 months ago, show only plans to encourage active subscriptions.

    return false;
}